import React, { useMemo } from 'react'
import { useGetTreeById, useResetForTree } from '../../../reducers/trees_hooks'
import { Box } from '@mui/material'
import { INode } from 'shared/types/tree'
import { Table } from 'shared/ui/Table/Table'
import { Column } from 'shared/ui/Table/types'
import { updateNodeListType } from '../utility/utility'
import { ConfirmWithDialogButton } from 'shared/ui'
import { doInBatches } from '../../../utility'
import { nodeListsWithTypeIssue } from './utility'

export function NodeListType({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const { tree } = useGetTreeById({ treeId, versionId })
  if (!tree) {
    return <Box>Loading...</Box>
  }

  return <NodeListVerification tree={tree} />
}

function getTableColumns(tree: INode): Column<INode>[] {
  return [
    {
      title: 'Title',
      rowContent({ title }: INode) {
        return title
      },
    },
    {
      title: 'Type',
      rowContent({ nodes }: INode) {
        return nodes[0].type
      },
    },
    {
      title: 'Fix',
      rowContent(node: INode) {
        return <UpdateNodeListsButton tree={tree} nodeLists={[node]} />
      },
    },
  ]
}

function NodeListVerification({ tree }: { tree: INode }) {
  const badNodeLists = nodeListsWithTypeIssue(tree)

  const tableColumns = useMemo(() => {
    return getTableColumns(tree)
  }, [tree])

  return (
    <Table<INode>
      title={`${badNodeLists.length} Nodes To Fix`}
      columns={tableColumns}
      items={badNodeLists}
      toolBarItems={[
        <UpdateNodeListsButton
          key="updateButton"
          tree={tree}
          nodeLists={badNodeLists}
        />,
      ]}
    />
  )
}

export function UpdateNodeListsButton({
  tree,
  nodeLists,
}: {
  tree: INode
  nodeLists: INode[]
}) {
  const resetTree = useResetForTree(tree)

  const doIt = async () => {
    await doInBatches(nodeLists, updateNodeListType)
    resetTree()
  }

  return (
    <ConfirmWithDialogButton
      dialogTitle={`Updating ${nodeLists.length} Nodes`}
      dialogContent={''}
      onClick={doIt}
    >{`Update ${nodeLists.length}`}</ConfirmWithDialogButton>
  )
}
